module.exports = __webpack_public_path__ + "components/rewards/hourly/static/logo-0ecfae0ab70b44cf856595feefb705d7.jpg";